import React, {useState,useEffect} from "react";
import { StyleSheet, Text, View, Button, ImageBackground,Image,Dimensions,TouchableOpacity,TextInput, Alert} from "react-native";
import imgSrc2 from './images/clemgram_black.jpg';
import prof1 from './images/prof1.png';
import whocansee from './images/whocansee.png';
import sharee from './images/sharee.png';
import addlocation from './images/addlocation.png';
import tagging from './images/tagging.png';
import whocanseeclose from './images/whocanseeclose.png';
import everyone from './images/everyone.png';
import friends from './images/friends.png';
import addlocationn2 from './images/addlocationn2.png';
import addlocationn from './images/addlocationn.png';
import backk from './images/backk.png';



import { initializeApp } from "firebase/app";
import { getDatabase, ref, set,update } from "firebase/database";
//<ImageBackground source={imgSrc} resizeMode="cover" style={styles.image}>

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
    // ...
    apiKey: "AIzaSyB3kIHJz7Ey5FXzUVsN5Gfjp8tBaG6xYbw",
      authDomain: "stress-and-privacy.firebaseapp.com",
    databaseURL: "https://stress-and-privacy-default-rtdb.firebaseio.com",
      projectId: "stress-and-privacy",
      storageBucket: "stress-and-privacy.appspot.com",
      messagingSenderId: "738098786959",
      appId: "1:738098786959:web:a6469cc294345688a476fa" 
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  
  
  // Initialize Realtime Database and get a reference to the service
  const database = getDatabase(app);

const Info = (props) => {
	const [firstname,setFirstname]=useState('nameeeeeeeeee');
	const [postns,setPostns]=useState('');
	const [email,setEmail]=useState('');
	//const [firstname,setFirstname]=useState(props.navigation.state.params.firstname);
	const [see,setSee]=useState('everyone');
  const [loc,setLoc]=useState('add');
  const [seep,setSeep]=useState(whocansee);
	const [step,setStep]=useState(1);
  const [tagp,setTagp]=useState('');
	//const [bio,setBio]=useState(props.navigation.state.params.bio);
	//const [lastname,setLastname]=useState(props.navigation.state.params.lastname);
	//const [email,setEmail]=useState(props.navigation.state.params.email);
if(step===1)
{
		return( 
		           
			<View style={styles.container}>
				<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left',marginRight:35,marginLeft:35}}>
				
				
				<Text style={styles.text12}>Write a post explaining your opinion about a political controversy, such as your thoughts on current or past US president.</Text>
				</View>
				<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center'}}>
				<View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign:'right'}}>
				<Text style={styles.text2}>                           </Text>
				<Text style={styles.text2}>New post </Text>
        <TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center'}}
		 onPress={() => {
      if(postns==='')
      {
        alert('You must write the post!')
      }
      else{
		update(ref(database, 'users/' + props.navigation.state.params.email.toString()), {
			post_sens:postns,
			loc_sens:loc,
			tag_sens:tagp,
			cansee_sens:see,
		  });
          props.navigation.navigate('Clemazon',{email: props.navigation.state.params.email});
          }     
			}}>
			  <Image         
					style={styles.ipost}
					resizeMode={'center'}
					source={sharee}/>
			</TouchableOpacity>
      	</View>
        
        <TextInput
					style={styles.textArea}
          placeholderTextColor="grey"
					numberOfLines={40}
					//editable = {false}
					multiline={true}
					onChangeText={(name) => setPostns(name)}
					placeholder="Write your post here."
					value={postns}/>


<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center'}}
		 onPress={() => {
					setStep(4);	
			}}>
			  <Image         
					style={styles.ip}
					resizeMode={'center'}
					source={tagging}/>
			</TouchableOpacity>


      <TouchableOpacity style={{flexDirection:"row",alignItems:'left',justifyContent:'left'}}
		 onPress={() => {
      setStep(3);
			}}>
			  <Image         
					style={styles.ip}
					resizeMode={'center'}
					source={addlocation}/>
			</TouchableOpacity>

      <TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center'}}
		 onPress={() => {
						setStep(2);
			}}>
			  <Image         
					style={styles.ip}
					resizeMode={'center'}
					source={seep}/>
			</TouchableOpacity>
        </View>
				
			</View>
		
		)
    }
    else if(step===2)//who can see	
    {
      return( 
      <View style={styles.container}>
      <View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign:'center',marginRight:35,marginLeft:35}}>
      
      
      <Text style={styles.text62}>Who can see your post?</Text>
      </View>
      <View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center'}}>
      
      <TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:30}}
   onPress={() => {
    setSee('everyone');
    setSeep(whocansee);
    setStep(1);          
    }}>
      <Image         
        style={styles.ips}
        resizeMode={'center'}
        source={everyone}/>
    </TouchableOpacity>
    
    
<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:30}}
   onPress={() => {
    setSee('friends');
    setSeep(whocanseeclose);
    setStep(1);
    }}>
      <Image         
        style={styles.ips}
        resizeMode={'center'}
        source={friends}/>
    </TouchableOpacity>


      </View>
      
    </View>
  
  )
    }
    else if(step===3)//Add location	
    {
      return( 
        <View style={styles.container}>
        <View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign:'center',marginRight:35,marginLeft:35}}>
        
        
        <Text style={styles.text62}>Share Location?</Text>
        </View>
        <View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center'}}>
        
        <TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:30}}
     onPress={() => {
		setLoc('add');
      setStep(1);          
      }}>
        <Image         
          style={styles.ips}
          resizeMode={'center'}
          source={addlocationn}/>
      </TouchableOpacity>
      
      
  <TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:30}}
     onPress={() => {
		setLoc('noadd');
      setStep(1);
      }}>
        <Image         
          style={styles.ips}
          resizeMode={'center'}
          source={addlocationn2}/>
      </TouchableOpacity>
  
  
        </View>
        
      </View>
    
    )
    }	
		else if(step===4)//tag people
    {
      return( 
        <View style={styles.container}>
        <View style={{flexDirection:"row",alignItems:'center',justifyContent:'center',textAlign:'center',marginRight:35,marginLeft:35}}>
        
        
        <Text style={styles.text12}>Tag your Clemson friends </Text>
        </View>
        <View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:85}}>
        
        <TextInput
					style={styles.textArea2}
          placeholderTextColor="grey"
					numberOfLines={10}
					//editable = {false}
					multiline={true}
					onChangeText={(name) => setTagp(name)}
					placeholder="Write people's names separated with a comma."
					value={tagp}/>
  <TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
						 onPress={() => {
							setStep(1);
							}}>
							<Image         
								style={styles.iedit}
								resizeMode={'center'}
								source={backk}/>
						</TouchableOpacity>
        </View>
        
      </View>
    
    )
    }




}
//	{false}<Text style={styles.text4}>Your Facebook profile is where other people can post their thoughts, opinions, views, or criticisms about you for everyone to see. </Text>
                               
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 25,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "left",
		backgroundColor:"black",
	},
	button: {
		alignItems: "center",
		backgroundColor: "#DDDDDD",
		padding: 10
	  },
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'center',
    flexDirection: "column",
		justifyContent: "center",
	},
	ichart: {
		height: Dimensions.get('window').height/15,
		width: Dimensions.get('window').width/13,
	  }, 
	  iedit: {
		height: Dimensions.get('window').height/10,
		width: Dimensions.get('window').width/8,
	  }, 
	  ipro: {
		height: Dimensions.get('window').height/3,
		width: Dimensions.get('window').width/3,
	  },
	  ip: {
		height: Dimensions.get('window').height/9.5,
		width: Dimensions.get('window').width/4,
    marginBottom:12,
	  }, 
    ips: {
      height: Dimensions.get('window').height/6.5,
      width: Dimensions.get('window').width/3.5,
      marginBottom:12,
      }, 
	  ipost: {
		height: Dimensions.get('window').height/8.5,
		width: Dimensions.get('window').width/8.5,
    marginLeft:95
	  },
	buttonContainer:{
		width: '15%',
		alignSelf: 'center',
		marginTop: 80,
	},
	iweb2: {
		height: Dimensions.get('window').height/2.7,
		width: Dimensions.get('window').width/4,
		marginLeft: 1
	  },
	text: {
		
		fontSize: Dimensions.get('window').width/50,
		color:'#3a9BDC',
		marginRight: 5,
		marginLeft: 5,
	},
    text2: {
		fontWeight: "bold",
		fontSize: 40,        
    marginBottom: 15,
    marginRight: 75,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text12: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
  text62: {
		//fontWeight: "bold",
		fontSize: 60,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
    text4: {
		fontSize: 20,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,  
		textDecorationLine: 'underline',      
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text5: {
		fontSize: 16,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text6: {
		fontSize: 22, 
		fontWeight: "bold",       
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'blue',
		fontFamily: "sans-serif-condensed",
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	text3: {
		marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'center',
		fontSize: Dimensions.get('window').width/70,
		color:'#03C04A',
		marginRight: Dimensions.get('window').width/5,
		marginLeft: Dimensions.get('window').width/5,
		
	},

	  textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:Dimensions.get('window').width/2.5,
		paddingLeft: Dimensions.get('window').width/2.5,
		paddingBottom: 30,
		textAlign: 'center',

	  },
    
	  textArea: {
		height: 200,
		width:950,
		fontSize: 20,
		borderColor: 'orange',
		backgroundColor:'white',
		color:'black',
		borderWidth: 3,
		marginBottom: 20,
		justifyContent: "center"
	  },
    textArea2: {
      height: 120,
      width:650,
      fontSize: 20,
      borderColor: 'orange',
      backgroundColor:'white',
      color:'black',
      borderWidth: 3,
      marginBottom: 20,
      justifyContent: "center"
      },
	  checkboxContainer: {
		flexDirection: "row",
		
	  },
	  checkbox: {
		alignSelf: "center",
	  },
})
export default Info